import alinaC from 'images/payments/alina_c.jpg';
import annaC1 from 'images/payments/anna_c_1.jpg';
import annaC2 from 'images/payments/anna_c_2.png';
import bhaktiC1 from 'images/payments/bhakti_c_1.png';
import bhaktiC2 from 'images/payments/bhakti_c_2.png';
import chelseaR from 'images/payments/chelsea_r.jpg';
import dougW1 from 'images/payments/doug_w_1.png';
import dougW2 from 'images/payments/doug_w_2.png';
import elenaM1 from 'images/payments/elena_m_1.jpg';
import elenaM2 from 'images/payments/elena_m_2.png';
import emmanuelA from 'images/payments/emmanuel_a.jpg';
import gonzaloO from 'images/payments/gonzalo_o.jpg';
import kathleenB1 from 'images/payments/kathleen_b_1.jpg';
import kathleenB2 from 'images/payments/kathleen_b_2.png';
import kunyuH from 'images/payments/kunyu_h.jpg';
import leahB1 from 'images/payments/leah_b_1.jpg';
import leahB2 from 'images/payments/leah_b_2.png';
import mirela from 'images/payments/mirela.jpg';
import pompromR1 from 'images/payments/pomprom_r_1.jpg';
import pompromR2 from 'images/payments/pomprom_r_2.png';
import sarahS from 'images/payments/sarah_s.jpg';
import tamirL1 from 'images/payments/tamir_l_1.jpg';
import tamirL2 from 'images/payments/tamir_l_2.png';
import tristenA from 'images/payments/tristen_a.jpg';
import valS from 'images/payments/val_s.jpg';
import yeshwanthC1 from 'images/payments/yeshwanth_c_1.png';
import yeshwanthC2 from 'images/payments/yeshwanth_c_2.png';

import _t from 'i18n!nls/payments';

export type Testimonial = {
  userName: string;
  photoUrl: string;
  caption: string;
};

// The component might be used in multiple sections of the same page.
// This global variable is to ensure it will show the same testimonial across the component instances
let CACHED_TESTIMONIAL: Testimonial | undefined;
let CACHED_PAID_VALUE_PROP_TESTIMONIAL: Testimonial | undefined;

const getTestimonials = (shouldUseShortTestimonials?: boolean): Array<Testimonial> => {
  const normalTestimonials = [
    {
      userName: 'Ana C.',
      photoUrl: `${annaC1}`,
      caption: _t(
        'The courses I took taught me how to turn theory into concrete & systematic practice. Coursera has been paramount to the advancement of my career.'
      ),
    },
    {
      userName: 'Doug W.',
      photoUrl: `${dougW1}`,
      caption: _t(
        'Coursera formed the backbone of my education. The courses focus on deep conceptual understanding and mastery, rather than just learning a skill.'
      ),
    },
    {
      userName: 'Kathleen B.',
      photoUrl: `${kathleenB1}`,
      caption: _t(
        'The courses I took on Coursera are directly applicable to my job. They enable me to learn things I can use at work immediately.'
      ),
    },
    {
      userName: 'Bhakti C.',
      photoUrl: `${bhaktiC1}`,
      caption: _t(
        'Coursera proved instrumental in arming me with the knowledge I need to truly understand core concepts in my field.'
      ),
    },
    {
      userName: 'Tamir L.',
      photoUrl: `${tamirL1}`,
      caption: _t(
        'Coursera has been a source of intellectual enrichment and practical professional development for me.'
      ),
    },
    {
      userName: 'Yeshwanth C.',
      photoUrl: `${yeshwanthC1}`,
      caption: _t(
        'The great thing about Coursera is the flexibility. You can learn anywhere, which is better than a rigid campus curriculum.'
      ),
    },
    {
      userName: 'Leah B.',
      photoUrl: `${leahB1}`,
      caption: _t(
        'I attribute a lot to Coursera – it’s given me not only career skills, but passion and meaning in my life.'
      ),
    },
    {
      userName: 'Elena M.',
      photoUrl: `${elenaM1}`,
      caption: _t('Coursera helped me learn skills to develop my career and enrich my expertise.'),
    },
    {
      userName: 'Ponprom R.',
      photoUrl: `${pompromR1}`,
      caption: _t(
        'Coursera gives me a platform to explore new skills. I was able to experience education from world-renowned universities without losing out on career opportunities.'
      ),
    },
  ];

  const shortTestimonials = [
    {
      userName: 'Ana C.',
      photoUrl: `${annaC2}`,
      caption: _t('Coursera has been paramount to the advancement of my career.'),
    },
    {
      userName: 'Doug W.',
      photoUrl: `${dougW2}`,
      caption: _t('Coursera formed the backbone of my education.'),
    },
    {
      userName: 'Kathleen B.',
      photoUrl: `${kathleenB2}`,
      caption: _t('The courses I took on Coursera are directly applicable to my job.'),
    },
    {
      userName: 'Bhakti C.',
      photoUrl: `${bhaktiC2}`,
      caption: _t('Coursera proved instrumental in arming me with the knowledge I truly need.'),
    },
    {
      userName: 'Tamir L.',
      photoUrl: `${tamirL2}`,
      caption: _t('Coursera is a source of intellectual enrichment and professional development.'),
    },
    {
      userName: 'Yeshwanth C.',
      photoUrl: `${yeshwanthC2}`,
      caption: _t('The best thing about Coursera is the flexibility. You can learn anywhere.'),
    },
    {
      userName: 'Leah B.',
      photoUrl: `${leahB2}`,
      caption: _t('I attribute a lot to Coursera — it gives me career skills as well as passion & meaning in my life.'),
    },
    {
      userName: 'Elena M.',
      photoUrl: `${elenaM2}`,
      caption: _t('Coursera helped me learn skills to develop my career and enrich my expertise.'),
    },
    {
      userName: 'Ponprom R.',
      photoUrl: `${pompromR2}`,
      caption: _t(
        'With Coursera, I was able to experience education from top universities without losing out on career opportunities.'
      ),
    },
  ];
  return shouldUseShortTestimonials ? shortTestimonials : normalTestimonials;
};

const paidValuePropTestimonials = (): Array<Testimonial> => {
  return [
    {
      userName: 'Kunyu H.',
      photoUrl: `${kunyuH}`,
      caption: _t(
        'With the technical skills I learned on Coursera, I landed an internship for the summer at an investment management firm.'
      ),
    },
    {
      userName: 'Sarah S.',
      photoUrl: `${sarahS}`,
      caption: _t(
        `Since completing the certificate, I’ve gotten many internship interviews and I'm currently interning at IBM!`
      ),
    },
    {
      userName: 'Emmanuel A.',
      photoUrl: `${emmanuelA}`,
      caption: _t(
        'The great content, exercises, and labs on Coursera gave me confidence during my technical interviews.'
      ),
    },
    {
      userName: 'Valerie S.',
      photoUrl: `${valS}`,
      caption: _t(
        `I'm re-entering the workforce after a long hiatus and Coursera's been essential in refurbishing my toolkit.`
      ),
    },
    {
      userName: 'Mirela I.',
      photoUrl: `${mirela}`,
      caption: _t('After I completed my certificate on Coursera, I was able to transition roles within my company.'),
    },
    {
      userName: 'Tristen A.',
      photoUrl: `${tristenA}`,
      caption: _t(
        'My certificate showed the hiring manager that I had the technical aptitude for the role I was applying for.'
      ),
    },
    {
      userName: 'Chelsea R.',
      photoUrl: `${chelseaR}`,
      caption: _t(
        'The relevant course content allowed me to speak knowledgeably throughout my interviews and to implement practical uses for what I learned.'
      ),
    },
    {
      userName: 'Gonzalo O.',
      photoUrl: `${gonzaloO}`,
      caption: _t(
        'The skills and knowledge I gained from the courses helped me pass my interviews, secure the job, and grow within the company.'
      ),
    },
    {
      userName: 'Alina C.',
      photoUrl: `${alinaC}`,
      caption: _t(
        'After listing my certificates on LinkedIn and my course projects on Github, recruiters reached out and invited me for interviews.'
      ),
    },
  ];
};

const getTestimonial = (shouldUseShortTestimonials = false, randomNumber?: number): Testimonial => {
  if (randomNumber || !CACHED_TESTIMONIAL) {
    const testimonials = getTestimonials(shouldUseShortTestimonials);
    const testimonialIndex = Math.floor((randomNumber ?? Math.random()) * testimonials.length);
    CACHED_TESTIMONIAL = testimonials[testimonialIndex];
  }
  return CACHED_TESTIMONIAL;
};

const getPaidValuePropTestimonial = (): Testimonial => {
  if (!CACHED_PAID_VALUE_PROP_TESTIMONIAL) {
    const testimonials = paidValuePropTestimonials();
    const testimonialIndex = Math.floor(Math.random() * testimonials.length);
    CACHED_PAID_VALUE_PROP_TESTIMONIAL = testimonials[testimonialIndex];
  }
  return CACHED_PAID_VALUE_PROP_TESTIMONIAL;
};

export { getTestimonial, getTestimonials, getPaidValuePropTestimonial };
